import { Component, inject } from '@angular/core';
import { HourTypeService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  HourTypeCreateDto,
  HourTypeDto,
  HourTypeExcelDownloadDto,
  HourTypeUpdateDto,
} from '../proxy/general/dtos/hour-type';
import { HOURTYPE_CONFIG, HOURTYPE_FIELDS } from './hour-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-hour-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, HourTypeService, ConfirmationService],
  templateUrl: './hour-type.html',
  styleUrl: './hour-type.scss',
})
export class HourType extends BaseCrudComponent<
  HourTypeDto,
  HourTypeCreateDto,
  HourTypeUpdateDto,
  HourTypeExcelDownloadDto
> {
  service = inject(HourTypeService);
  config = HOURTYPE_CONFIG;
  fields = HOURTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: HourTypeDto): HourTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      startHour: data.startHour,
      endHour: data.endHour,
      coefficient: data.coefficient,
      isVisibleInMobile: data.isVisibleInMobile,
      condition: data.condition,
      hourTypeGroupId: data.hourTypeGroupId,
      vendorId: data.vendorId,
      equivalentHourId: data.equivalentHourId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'HourType';
  }
}
